import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge45 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='PGMグループのエリア別優待制度とは？' fontWeight={700} />
                <p>
                    PGMグループとは、パシフィックゴルフマネージメント株式会社が運営する、国内で140以上のゴルフ場を保有するゴルフ場グループです。
                    <br />
                    PGMグループのゴルフ会員権には「P-CAP」という会員特典プログラムが用意されており、その中の「優待料金プログラム」では、全国のPGMグループのゴルフ場を優待料金でプレーすることができます。
                    <br />
                    コース数が多いため、どのエリアにどのコースがあるかを把握したうえで会員権を選ぶことが、PGMグループの会員権選びのポイントになります。
                </p>
                <p>
                    P-CAP制度の詳細（追加入会割引・家族入会割引・預託金充当制度など）については、
                    <a href='/knowledge/21'>PGMグループの会員権を解説した記事</a>
                    で詳しくご紹介しています。本記事では、エリアごとのコース選びに焦点を当ててご紹介します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='エリアで選ぶPGMグループのゴルフ会員権' fontWeight={700} />
                <Heading3 title='首都圏・関東エリア' />
                <p>
                    東京からのアクセスを重視する方には、千葉・茨城エリアのコースが人気です。
                    <br />
                    例えば総武カントリークラブは、総武コース・印旛コース・北コースの合計54ホールを擁し、東京からのアクセスも良好なため、平日・週末問わず利用したい方に選ばれています。
                </p>
                <Heading3 title='関西エリア' />
                <p>
                    関西エリアでは、茨木国際ゴルフ倶楽部のように大阪市内を一望できるコースなど、アクセスの良さと眺望を両立したコースがあります。
                </p>
                <Heading3 title='沖縄・リゾートエリア' />
                <p>
                    リゾート地でのゴルフを楽しみたい方には、PGMゴルフリゾート沖縄のような、青木功プロが改造監修を手掛けたリゾートコースもPGMグループの選択肢に含まれます。
                </p>
                <p>
                    ※P-CAPの優待料金プログラムは、対象となるコースの組み合わせによって優待内容が異なる場合があります。エリアごとの具体的な優待料金・対象コースの組み合わせは変更される場合がありますので、最新情報は公式サイトまたは弊社にご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='PGMグループのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    PGMグループの全国のゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=6' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                </p>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/73'>総武カントリークラブ</a>（千葉県）
                </div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/493'>茨木国際ゴルフ倶楽部</a>（大阪府）
                </div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/658'>PGMゴルフリゾート沖縄</a>（沖縄県）
                </div>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    PGMグループはコース数が多いため、ライフスタイルの変化（転勤・複数拠点での利用など）に合わせてエリアを選びやすいことが魅力です。
                    <br />
                    <br />
                    ご希望のエリアや優待条件に合わせたコース選びについては、お気軽に弊社にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge45;
